import jwt from "njwt";
import { digestPromptQuery, graphSearchQuery } from "./schemas.js";
export function toUrl(orgId, path) {
  const id = process.env.INTEGRATIONS_MOCK_ORG_ID || orgId;
  return `${process.env.INTEGRATIONS_HOST}/api/v1/orgs/${id}/${path}`;
}
export async function doGet(url, authed) {
  const [token] = createToken(authed);
  return await fetch(url, {
    method: "GET",
    headers: {
      "X-VZBL-AUTH": token.compact(),
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
}
export async function doPost(url, authed, params) {
  const [token, orgId] = createToken(authed);
  return await fetch(url, {
    method: "POST",
    body: JSON.stringify({ ...params, orgId }),
    headers: {
      "X-VZBL-AUTH": token.compact(),
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
}
// gets a token for auth, and the orgId used in it
function createToken(clientInfo) {
  const orgId =
    process.env.INTEGRATIONS_MOCK_ORG_ID || (clientInfo.orgId ?? "");
  const token = jwt.create(
    {
      iss: "vzbl-auth",
      sub: "web-app",
      uid: clientInfo.userId ?? "",
      oid: orgId,
      rol: clientInfo.orgUserRole ?? "",
    },
    process.env.INTEGRATIONS_SECRET,
  );
  token.setExpiration(Date.now() + 60 * 1000);
  return [token, orgId];
}
// recursively find the actual data to return
export function extractData(it) {
  if (!it) return [];
  if (!it.data) return it;
  return extractData(it.data);
}
// similar function for similar need
export function extractMeta(it) {
  if (!it) return {};
  if (it.meta) return it.meta;
  if (!it.data) return {};
  return extractMeta(it.data);
}
export function getSearchQuery(input) {
  const params = graphSearchQuery().parse(input);
  // TODO this requirement should find its way into the query builder
  const duration = // date ranges override any duration provided
    params.startDate && params.endDate ? undefined : params.duration;
  return { ...params, duration };
}
export function getDigestQuery(input) {
  const params = digestPromptQuery().parse(input);
  return params;
}
